__turbopack_context__.v({
  "actions": "MtmyuG_actions",
  "activeQuestion": "MtmyuG_activeQuestion",
  "answerLabel": "MtmyuG_answerLabel",
  "brand": "MtmyuG_brand",
  "chargeImpact": "MtmyuG_chargeImpact",
  "chargeOrbit": "MtmyuG_chargeOrbit",
  "charged": "MtmyuG_charged",
  "charging": "MtmyuG_charging",
  "choice": "MtmyuG_choice",
  "choiceMeta": "MtmyuG_choiceMeta",
  "choiceVoters": "MtmyuG_choiceVoters",
  "choices": "MtmyuG_choices",
  "compactLayout": "MtmyuG_compactLayout",
  "composer": "MtmyuG_composer",
  "conclusion": "MtmyuG_conclusion",
  "connectedFlow": "MtmyuG_connectedFlow",
  "connectedGrain": "MtmyuG_connectedGrain",
  "contribution": "MtmyuG_contribution",
  "copyPulse": "MtmyuG_copyPulse",
  "countdown": "MtmyuG_countdown",
  "create": "MtmyuG_create",
  "customAnswer": "MtmyuG_customAnswer",
  "decision": "MtmyuG_decision",
  "discussion": "MtmyuG_discussion",
  "empty": "MtmyuG_empty",
  "enter": "MtmyuG_enter",
  "error": "MtmyuG_error",
  "eyebrow": "MtmyuG_eyebrow",
  "footer": "MtmyuG_footer",
  "form": "MtmyuG_form",
  "hero": "MtmyuG_hero",
  "heroActions": "MtmyuG_heroActions",
  "heroGradientDrift": "MtmyuG_heroGradientDrift",
  "heroText": "MtmyuG_heroText",
  "invite": "MtmyuG_invite",
  "inviteCopied": "MtmyuG_inviteCopied",
  "inviteCopy": "MtmyuG_inviteCopy",
  "loading": "MtmyuG_loading",
  "lobby": "MtmyuG_lobby",
  "lobbyHeader": "MtmyuG_lobbyHeader",
  "lobbyPeople": "MtmyuG_lobbyPeople",
  "nameButton": "MtmyuG_nameButton",
  "nameControl": "MtmyuG_nameControl",
  "nameError": "MtmyuG_nameError",
  "nameForm": "MtmyuG_nameForm",
  "nav": "MtmyuG_nav",
  "nextRound": "MtmyuG_nextRound",
  "nextRoundPrompt": "MtmyuG_nextRoundPrompt",
  "optionEditor": "MtmyuG_optionEditor",
  "optionInput": "MtmyuG_optionInput",
  "optional": "MtmyuG_optional",
  "overviewHeader": "MtmyuG_overviewHeader",
  "overviewMeta": "MtmyuG_overviewMeta",
  "page": "MtmyuG_page",
  "poster": "MtmyuG_poster",
  "posterGradientDrift": "MtmyuG_posterGradientDrift",
  "posterTop": "MtmyuG_posterTop",
  "primary": "MtmyuG_primary",
  "questionDraft": "MtmyuG_questionDraft",
  "questionEditor": "MtmyuG_questionEditor",
  "questionInput": "MtmyuG_questionInput",
  "questionNumber": "MtmyuG_questionNumber",
  "recommendChoice": "MtmyuG_recommendChoice",
  "recommended": "MtmyuG_recommended",
  "resultsNextStep": "MtmyuG_resultsNextStep",
  "reviewAnswers": "MtmyuG_reviewAnswers",
  "reviewChevron": "MtmyuG_reviewChevron",
  "reviewClip": "MtmyuG_reviewClip",
  "reviewPanel": "MtmyuG_reviewPanel",
  "reviewQuestion": "MtmyuG_reviewQuestion",
  "reviewToggle": "MtmyuG_reviewToggle",
  "roomHeader": "MtmyuG_roomHeader",
  "roomLayout": "MtmyuG_roomLayout",
  "roster": "MtmyuG_roster",
  "roundFooter": "MtmyuG_roundFooter",
  "secondary": "MtmyuG_secondary",
  "startAction": "MtmyuG_startAction",
  "startError": "MtmyuG_startError",
  "steps": "MtmyuG_steps",
  "voteCount": "MtmyuG_voteCount",
  "voterAvatar": "MtmyuG_voterAvatar",
  "workshopList": "MtmyuG_workshopList",
  "workspace": "MtmyuG_workspace",
  "writtenAnswer": "MtmyuG_writtenAnswer",
});
